import request from "utils/request";

//获取设置
export function specification() {
  return request({
    url: `/setting/list/rankALL`,
    method: "POST",
  })
};
//更新设置
export function updateListrankALL(settingList) {
  return request({
    url: `/setting/list/updateListrankALL`,
    method: "POST",
    data: {
      settings:settingList
    }
  })
};
